
















































































































































































































































































































import { Vue, Component, Watch } from "vue-property-decorator";
import { Form, Calendar, Picker, Cell, Button,Field,Uploader,Popup} from "vant";
import dataShare from "../../mall/dataShare";
import moment from "moment";
import bus from "../components/bus";
import btripServcice from "@/service/btripServcice";
@Component({
  name: "cardModify",
  components: {
    [Form.name]: Form,
    [Calendar.name]: Calendar,
    [Picker.name]: Picker,
    [Cell.name]: Cell,
    [Button.name]: Button,
    [Field.name]: Field,
    [Uploader.name]: Uploader,
    [Popup.name]: Popup
  },
})
export default class extends Vue {
  dataShare = dataShare;
  get City() {
    return this.dataShare.City;
  }
  set City(value: any) {
    this.dataShare.City = value;
  }

  isShow = {
    isShowTaskDate: false,
    isShowTaskDateEnd: false,
    isShowRegion: false,
    isShowTaskDay: false,
    isShowJobs: false,
    isShowScientific: false,
    isShowDesign: false,
    isShowAdministration: false,
    isShowSociology: false,
    isShowManagement: false,
    isShowDevelopment: false,
    isShowCommittee: false,
    isShowCitySelecter: false,
    isShowTicketBuyer: false,
    isShowBuyer: false,
    isShowCost: false,
    isShowMajor: false,
  };
  validator(val: any) {
    return /\S/.test(val);
  }
  local = {
    PickerRegion: ["外地", "本地"],
    PickerJobs: ["科研工作", "设计工作", "管理工作", "社会工作", "经营工作", "研发中心工作", "专业委员会工作"],
    PickerTicket: ["是", "否"],
    PickerCost: [
      {
        text: "五、生产管理成本",
        children: [
          {
            text: "(一)、生产管理成本",
            children: [{ text: "9、差旅费" }],
          },
        ],
      },
      {
        text: "七、科研成本",
        children: [
          {
            text: "(一)、专项科研成本",
            children: [
              {
                text: "7、差旅费",
              },
            ],
          },
          {
            text: "(二)、企业研究开发费",
            children: [
              {
                text: "7、差旅费",
              },
            ],
          },
        ],
      },
    ],
    PickerMajor: ["评估"],
  };
  activated() {
    (this.dictOthers.DepartmentName = String(this.profile.DepartmentName)),
      (this.dictOthers.UserName = String(this.profile.UserName)),
      bus.$on("projectEvent", (project: any) => {
        this.sendForm.ProjectCode = project.ProjectCode;
        this.sendForm.ProjectName = project.ProjectName;
        this.sendForm.ProjectID = project.ProjectID;
      });
    if (this.selectCode && this.City && this.City.value) {
      let City = this.City;
      if (this.selectCode == "DepartCity") {
        this.dictOthers.DepartCityName = this.City.label;
        this.dictOthers.DepartCityID = this.City.CountryID;
      } else if (this.selectCode == "ArriveCity") {
        this.dictOthers.ArriveCityName = this.City.label;
        this.dictOthers.ArriveCityID = this.City.CountryID;
      }
    }
  }
  TaskInfo = {};
  TaskInfoDictothers = {};
   handleResult = {
    TaskID: "",
    TaskStatus: "",
  };
  created(){
    this.sendForm = Object(this.$route.params.item);
    this.dictOthers = (this.sendForm as any).dictOthers;
    this.handleResult.TaskID = (this.TaskInfo as any).TaskID;
    this.sendForm.TaskDate = moment(this.sendForm.TaskDate).format("YYYY-MM-DD");
    this.sendForm.TaskDateEnd = moment(this.sendForm.TaskDate).format("YYYY-MM-DD");
    console.log("新拿到的",this.sendForm);
    console.log("新拿到的",this.dictOthers);
    
    
  }
  staticState: any = {
    Deparment: "",
  };
  sendForm = {
    TaskID:"",
    TaskDate: "",
    TaskDateEnd: "",
    TaskName: "",
    ProjectID: "",
    ProjectName: "",
    ProjectCode: "",
    Major: "",
    TaskStatus: "",
    dictOthers: {},
  };

  dictOthers = {
    DepartmentName: "",
    UserName: "",
    Region: "",
    TaskDay: "",
    Reason: "",
    JobOptions: "",
    DepartCityID: "",
    DepartCityName: "",
    ArriveCityID: "",
    ArriveCityName: "",
    TicketBuyer: "",
    Cost: "",
    content: "",
    CostCategorization: "",
    CostCategorizationItem: "",
  };
  FormDate: object = {};

  @Watch("dictOthers.JobOptions")
  onChangeJobValue(newVal: string, oldVal: string) {
    switch (newVal) {
      case "科研工作":
        this.isShow.isShowScientific = true;
        (this.isShow.isShowDesign = false),
          (this.isShow.isShowAdministration = false),
          (this.isShow.isShowSociology = false),
          (this.isShow.isShowManagement = false),
          (this.isShow.isShowDevelopment = false),
          (this.isShow.isShowCommittee = false);
        break;
      case "设计工作":
        this.isShow.isShowScientific = false;
        this.isShow.isShowDesign = true;
        (this.isShow.isShowAdministration = false),
          (this.isShow.isShowSociology = false),
          (this.isShow.isShowManagement = false),
          (this.isShow.isShowDevelopment = false),
          (this.isShow.isShowCommittee = false);
        break;
      case "管理工作":
        this.isShow.isShowScientific = false;
        (this.isShow.isShowDesign = false),
          (this.isShow.isShowAdministration = false),
          (this.isShow.isShowSociology = false),
          (this.isShow.isShowManagement = false),
          (this.isShow.isShowDevelopment = false),
          (this.isShow.isShowCommittee = false);
        break;
      case "社会工作":
        this.isShow.isShowScientific = false;
        (this.isShow.isShowDesign = false),
          (this.isShow.isShowAdministration = false),
          (this.isShow.isShowSociology = true),
          (this.isShow.isShowManagement = false),
          (this.isShow.isShowDevelopment = false),
          (this.isShow.isShowCommittee = false);
        break;
      case "经营工作":
        this.isShow.isShowScientific = false;
        (this.isShow.isShowDesign = false),
          (this.isShow.isShowAdministration = false),
          (this.isShow.isShowSociology = false),
          (this.isShow.isShowManagement = true),
          (this.isShow.isShowDevelopment = false),
          (this.isShow.isShowCommittee = false);
        break;
      case "研发中心工作":
        this.isShow.isShowScientific = false;
        (this.isShow.isShowDesign = false),
          (this.isShow.isShowAdministration = false),
          (this.isShow.isShowSociology = false),
          (this.isShow.isShowManagement = false),
          (this.isShow.isShowDevelopment = true),
          (this.isShow.isShowCommittee = false);
        break;
      case "专业委员会工作":
        this.isShow.isShowScientific = false;
        (this.isShow.isShowDesign = false),
          (this.isShow.isShowAdministration = false),
          (this.isShow.isShowSociology = false),
          (this.isShow.isShowManagement = false),
          (this.isShow.isShowDevelopment = false),
          (this.isShow.isShowCommittee = false);
        break;
    }
  }
  @Watch("dictOthers.Region")
  onChangeCityValue(newVal: string, oldVal: string) {
    if (newVal === "外地") {
      this.isShow.isShowCitySelecter = true;
    } else {
      this.isShow.isShowCitySelecter = false;
    }
  }
  @Watch("dictOthers.TicketBuyer")
  onChangeTicketValue(newVal: string, oldVal: string) {
    if (newVal === "是") {
      this.isShow.isShowBuyer = true;
    } else {
      this.isShow.isShowBuyer = false;
    }
  }
  selectTaskDateStart() {
    console.log("dakai");
    this.isShow.isShowTaskDate = true;
  }
  onConfirmTaskDate(date: any) {
    console.log(date);

    this.isShow.isShowTaskDate = false;
    this.sendForm.TaskDate = moment(date[0]).format("YYYY-MM-DD");
    this.sendForm.TaskDateEnd = moment(date[1]).format("YYYY-MM-DD");
    console.log(this.sendForm.TaskDate);
  }
  selectTaskDateEnd() {
    this.isShow.isShowTaskDate = true;
  }
  onConfirmTaskDateEnd(date: any) {
    this.isShow.isShowTaskDateEnd = false;
    this.sendForm.TaskDate = moment(date[0]).format("YYYY-MM-DD");
    this.sendForm.TaskDateEnd = moment(date[1]).format("YYYY-MM-DD");
  }
  selectJobs() {
    this.isShow.isShowJobs = true;
  }
  onConfirmPickerJobs(value: string) {
    this.dictOthers.JobOptions = value;
    this.isShow.isShowJobs = false;
  }
  onCancelisShowJobs() {
    this.isShow.isShowJobs = false;
  }
  ShowRegion() {
    console.log("弹窗打开");
    this.isShow.isShowRegion = true;
  }
  onConfirmPickerRegion(value: string) {
    console.log("选择了", value);
    this.dictOthers.Region = value;
    this.isShow.isShowRegion = false;
  }
  onCancelisShowRegion() {
    this.isShow.isShowRegion = false;
  }
  selectTaskDay() {
    console.log("选择外出天数");
    this.isShow.isShowTaskDay = true;
  }
  onConfirmTaskDay(value: any) {
    const start: number = value[0];
    const end: number = value[1];
    const utc: any = end - start;
    this.dictOthers.TaskDay = String(utc / (24 * 60 * 60 * 1000));
    this.isShow.isShowTaskDay = false;
  }
  selectCode = "";
  selectCity(cityType: string) {
    console.log("选择城市");
    this.City = null;
    this.selectCode = cityType;
    this.$router.push({
      path: "/selectCity",
    });
  }
  ShowTicketBuyer() {
    this.isShow.isShowTicketBuyer = true;
  }
  onConfirmPickerTicket(value: string) {
    this.dictOthers.TicketBuyer = value;
    this.isShow.isShowTicketBuyer = false;
  }
  onCancelisShowTicket() {
    this.isShow.isShowTicketBuyer = false;
  }
  slectBuyer() {
    console.log("选择");
  }
  showMajor() {
    this.isShow.isShowMajor = true;
  }
  onConfirmPickerMajor(value: string) {
    this.sendForm.Major = value;
    this.isShow.isShowMajor = false;
  }
  onCancelisShowMajor() {
    this.isShow.isShowMajor = false;
  }
  ShowCost() {
    console.log("费用类型");
    this.isShow.isShowCost = true;
  }
  onConfirmPickerCost(value: string) {
    this.dictOthers.Cost = value;
    this.isShow.isShowCost = false;
  }
  onCancelisShowCost() {
    this.isShow.isShowCost = false;
  }
  projectList() {
    this.$router.push({
      path: "/btrip/applicationForm/project/list",
      query: {
        title: this.dictOthers.JobOptions,
      },
    });
  }
  handleInfo() {
    (this.$refs["form"] as Form)
      .validate()
      .then(() => {
        this.dictOthers.CostCategorization = this.dictOthers.Cost[0];
        this.dictOthers.CostCategorizationItem = this.dictOthers.Cost[1];
        this.dictOthers.Cost = this.dictOthers.Cost[2];
        this.sendForm.TaskDate = String(Date.parse(this.sendForm.TaskDate));
        this.sendForm.TaskDateEnd = String(Date.parse(this.sendForm.TaskDateEnd));
        this.sendForm.dictOthers = this.dictOthers;
        btripServcice.saveTask(this.sendForm).then((json: any) => {
          if (json.isSucc) {
            this.$notify({ type: "success", message: "填写成功" });
            this.$router.replace({
              path: "/btrip/applicationList",
            });
          }
        });
      })
      .catch(() => {
        this.$notify({ type: "warning", message: "请确认表单填写完毕",duration: 200, });
      });
  }
  save() {
    this.sendForm.TaskStatus = "待提交";
    this.handleInfo();
  }
  submit() {
    this.sendForm.TaskStatus = "待审核";
    this.handleInfo();
  }
  onSubmit(values: any) {
    console.log("submit", values);
  }
}
